import {makeBFFApiUrl} from 'main/factories/http';

import {RemoteGetExamRequests} from 'data/usecases/private/exam-results/remote-get-exam-requests';
import {GetExamRequests} from 'domain/usecases/private/exam-results/get-exam-requests';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {BookedFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makeGetExamRequests = (): GetExamRequests =>
	new RemoteGetExamRequests(
		makeBFFApiUrl(BookedFlowEndPoints.examRequests),
		makeAuthorizeHttpClientDecorator(),
	);
